import React from 'react';
import Box from '@mui/material/Box';
import { Button } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    minHeight: '100vh',
    width: '100%',
    backgroundColor: '#e9e9e9',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      minHeight: 'auto',
      marginTop: 0,
      paddingTop: 0,
      paddingBottom: 0,
    },
    [theme.breakpoints.up('md')]: {
      marginTop: -50,
    },
  },
  contentSection: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 36px',
    [theme.breakpoints.up('md')]: {
      padding: '64px 56px',
    },
  },
  contentWrapper: {
    maxWidth: 580,
    width: '100%',
  },
  title: {
    margin: 0,
    fontSize: 46,
    lineHeight: 1.1,
    fontWeight: 900,
    fontStyle: 'italic',
    textTransform: 'uppercase',
    color: theme.palette.text.primary,
    [theme.breakpoints.down('sm')]: {
      fontSize: 34,
    },
  },
  description: {
    marginTop: 24,
    marginBottom: 0,
    fontSize: 22,
    lineHeight: 1.45,
    color: theme.palette.text.primary,
    [theme.breakpoints.down('sm')]: {
      fontSize: 18,
    },
  },
  tipsList: {
    marginTop: 20,
    marginBottom: 0,
    paddingLeft: 20,
    color: theme.palette.text.primary,
    '& li': {
      marginBottom: 8,
      fontSize: 18,
      lineHeight: 1.4,
      [theme.breakpoints.down('sm')]: {
        fontSize: 16,
      },
    },
  },
  actionButton: {
    marginTop: 34,
    minHeight: 48,
    borderWidth: 2,
    borderColor: theme.palette.text.primary,
    color: theme.palette.text.primary,
    padding: '10px 22px',
    fontWeight: 900,
    fontStyle: 'italic',
    textTransform: 'uppercase',
    '&:hover': {
      borderWidth: 2,
      borderColor: theme.palette.text.primary,
      backgroundColor: theme.palette.action.hover,
    },
  },
  imageSection: {
    flex: 1,
    backgroundImage: 'url(/images/error/404.avif)',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    minHeight: '100vh',
    [theme.breakpoints.down('md')]: {
      minHeight: 320,
      width: '100%',
      flex: '0 0 320px',
    },
  },
}));

const Error404 = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.root}>
      <Box className={classes.contentSection}>
        <Box className={classes.contentWrapper}>
          <Box component="h1" className={classes.title}>
            {t('extraPages.404Title')}
          </Box>

          <Box component="p" className={classes.description}>
            {t('extraPages.404Description')}
          </Box>

          <Box component="ul" className={classes.tipsList}>
            <Box component="li">{t('extraPages.404TipCheckUrl')}</Box>
            <Box component="li">{t('extraPages.404TipUseMenu')}</Box>
          </Box>

          <Button variant="outlined" color="inherit" className={classes.actionButton} component={Link} to="/">
            {t('extraPages.404GoHome')}
          </Button>
        </Box>
      </Box>

      <Box className={classes.imageSection} role="img" aria-label={t('extraPages.404ImageAlt')} />
    </Box>
  );
};

export default Error404;
